export default __webpack_public_path__ + "static/media/joystickInActive.75ac20e7.svg";